import React,{useState,useEffect} from "react";
import {  useParams } from 'react-router-dom';
import {getIdData } from "../../../lib/studentinfo"
import GlobalGradeInMonth from "../../pages/common/globalgradeinmonth";
import PageNotes from "../../pages/common/pagenotesnew";
import { useAuth } from "../../../usercontext";
import Student911TopMenu from "../studentInfo/student911topmenu"

export default function InstructorStudentGradeList() {

  let { slug } = useParams();

  const [studentInfo, setStudentInfo] = useState();
  const { profile, setProfile } = useAuth();

console.log("studentInfo",studentInfo);

  async function GetData() {
    const info = await getIdData(slug);
    setStudentInfo(info[0].class);
  }

useEffect(() => {
  GetData();
}, [])

  return (
            <>
            <Student911TopMenu slug={slug} activeMenu={"GradeList"} />
              <div className="tak-instruct-group">
                <div className="row">
                  <div className="col-md-12">                 
                    {studentInfo && (
                      <>
                      <PageNotes
              type={"Instructor"}
              pageName={"CurrentGrades"}
              studentId={slug}
              instructorId={profile.id}
            />
                      <GlobalGradeInMonth studentId={slug} ClassId={studentInfo} isStudent={false}/>      
            </>
                    )}
                    
                    {/*<GradeList slug={slug}/>*/}
                  </div>
                </div>
              </div>
            </>
  );
}
